<template>
    <div class="wrapper-logs">
        <div class="logs">
          <div class="toolbar sites__toolbar row justify-content-between">
            <div class="toolbar__left sites__actions col-12 col-lg-auto">

            </div>
            <div class="toolbar__right sites__search col-12 col-lg-auto">
              <div>
                <b-input-group>
                  <b-form-input
                    v-model="searchTerm"
                    class="form-control search"
                    type="search"
                    v-bind:placeholder="$t('log.entersitename')"
                    v-on:blur="changeSearch"
                    v-on:keyup.enter="changeSearch"
                  />
                  <b-input-group-append>
                    <button class="btn btn-primary">
                      <font-awesome-icon :icon="['fal','search']" class="fa-icon"></font-awesome-icon>
                    </button>
                  </b-input-group-append>
                </b-input-group>
              </div>
              <div class="ml-2">
                <b-dropdown id="columns-dropdown"
                            v-bind:text="$t('tableheadings.columns')"
                            variant="outline-primary"
                >
                  <b-dropdown-form>
                    <b-form-checkbox-group
                      id="column-select"
                      v-model="tableColumns"
                      name="columnselection"
                      stacked
                    >
                      <b-form-checkbox
                        v-for="col in columns"
                        :key="col.name"
                        :value="col.name"
                        class="mb-3 m-2"
                      >
                        {{ $t('tableheadings.' + col.name ) }}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-dropdown-form>
                </b-dropdown>
              </div>

              <div class="ml-2">
                <b-form-select
                  v-model="limit"
                  :options="limitOptions"
                  @change="limitChange"
                >
                </b-form-select>
              </div>
            </div>
          </div>
            <div class="table-responsive-lg">
                <table class="table table--overview">
                    <thead>
                    <tr>
                      <table-heading
                        v-for="(col, index) in columns"
                        :key="index"
                        class="text-center"
                        v-bind="{name: col.name, selected: tableColumns, sortEnabled: col.sortEnabled, sort: sort, dir: dir}"
                        @notifysort="sortColumn"
                      >
                      </table-heading>
                    </tr>
                    </thead>
                    <tbody>
                        <activity-item v-for="log in logs" :key="log.id" v-bind="log"></activity-item>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="5">
                            <nav v-show="showPagination" class="page navigation">
                                <b-pagination
                                        v-model="currentPage"
                                        align="left"
                                        v-bind:per-page="limit"
                                        v-bind:total-rows="total"
                                        v-on:change="goToPage"
                                >
                                </b-pagination>
                            </nav>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
      <div v-if="!isLoading">
        <empty-list v-if="showEmpty" @resetFilters="resetFilters"></empty-list>
      </div>

    </div>
</template>
<script>

import { mapActions, mapGetters, mapMutations } from 'vuex'
import ActivityItem from './ActivityItem'
import mixins from '@/mixins'
import TableHeading from '@/components/Common/TableHeading.vue'
import EmptyList from '@/components/Common/EmptyList.vue'

export default {

  name: 'Activity',

  components: {
    EmptyList,
    TableHeading,
    ActivityItem
  },

  mixins: [mixins],

  props: {

  },

  computed: {
    ...mapGetters('common', ['isLoading']),

    ...mapGetters('local', ['getListLimit']),

    ...mapGetters('local', { getColumns: 'getLogsColumns' }),

    limit: {
      get () {
        return this.getListLimit
      },
      set (value) {
        this.setListLimit(value)
      }
    },

    showEmpty () {
      return this.logs.length === 0 && this.isFiltered === true
    },

    isFiltered () {
      return this.searchTerm !== ''
    },

    tableColumns: {
      get () {
        return this.getColumns
      },
      set (value) {
        this.setColumns(value)
      }
    },

    limitOptions () {
      return this.getLimitOptions()
    },

    showPagination () {
      return this.totalPages > 1
    }
  },

  data () {
    return {
      logs: [],
      currentPage: 1,
      total: 1,
      totalPages: 1,
      sort: 'created_at',
      dir: 'desc',
      searchTerm: '',
      defaultSelectedColumns: [
        'name',
        'payload',
        'toVersion',
        'date'
      ],
      columns: [
        { name: 'name', sortEnabled: true },
        { name: 'payload', sortEnabled: true },
        { name: 'toVersion', sortEnabled: false },
        { name: 'date', sortEnabled: true }
      ]
    }
  },

  methods: {

    ...mapMutations([
      'setViewname'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ]),

    ...mapActions('log', [
      'getLogItems'
    ]),

    ...mapMutations('local', [
      'setListLimit'
    ]),

    ...mapMutations('local', { setColumns: 'setLogsColumns' }),

    resetFilters () {
      this.searchTerm = ''
      this.goToPage(1)
    },

    goToPage (page) {
      if (!this.isLoading) {
        this.startLoading()
      }

      let payload = {
        page: page,
        limit: this.limit,
        sort: this.sort,
        dir: this.dir,
        search: this.searchTerm
      }

      this.getLogItems(payload).then(
        response => {
          this.preparePage(response)
          this.endLoading()
        }
      )
    },

    preparePage (data) {
      let meta = data.meta

      this.limit = meta.pagination.per_page
      this.total = meta.pagination.total
      this.totalPages = meta.pagination.total_pages
      this.currentPage = meta.pagination.current_page

      this.logs = data.data
    }
  },

  mounted () {
    if (this.getColumns.length === 0) {
      this.setColumns(this.defaultSelectedColumns)
    }
  },

  created () {
    this.setViewname(this.$t('log.viewtitle'))
    this.goToPage(1)
  }
}
</script>
